<button
  color="{{ buttonColor }}"
  mat-button
  type="button"
  [ngClass]="{
    'doc-read-lookup-button':
      fieldData.type === 'custom-manual-lookup-document',
  }"
  (click)="triggerLookUp($event)"
>
  <mat-icon>search</mat-icon>{{ buttonLabel }}
</button>
